import React, { useEffect, useState } from "react";
// Importing toastify module
import { toast } from "react-toastify";
// Import toastify css file
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  CardBody,
  Input,
  CardTitle,
  FormGroup,
  Label,
  Button,
  FormText,
} from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import { saveUserDetails } from "../../services/AuthService";
import { firebaseLogout } from "../../services/AuthService";
import employeeLoginService from "../../services/AuthService";
import GooglePlacesComponent from "../components/GooglePlacesComponent";
import { isNullOrEmpty } from "../../config/ENV";
import PhoneInput from 'react-phone-input-2'
import {getPhoneNumberByCountryCode,validatePhoneNumber} from "../../utilities/phonenumberutility";
import 'react-phone-input-2/lib/style.css'
toast.configure();

const SignUp = () => {
  const [inputField, setInputField] = useState({
    name: "",
    website: "",
    contactNumber: "",
    fcmToken: "",
  });
  const [member, setMember] = useState({
    firstName: "",
    lastName: "",
    displayName:"",
    email: "",
    // contactNumber: "",
  });

  const [address, setAddress] = useState({
    street: "",
    area: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    latitude: "",
    longitude: "",
  });
  const [accept_terms_and_conditions, setAcceptTermsConditions] =
    useState(false);
  const [accept_privacy_policy, setAcceptPrivacyPolicy] = useState(false);

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [contactNumber,setContactNumber]=useState("")
  const [contactNumberCountryCode, setContactNumberCountryCode] = useState("1");
  const [memberContactNumber, setMemberContactNumber] = useState("");
  const [memberContactNumberCountryCode, setMemberContactNumberCountryCode] = useState("1");

  const [phoneNumber, setPhoneNumber] = useState("");
  const handlePhoneNumber = (value, country) => {
    setPhoneNumber(value);
    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setContactNumberCountryCode(dialCode);
      setContactNumber(mobileNumber);
    }
  };

  const [memberNumber, setMemberNumber] = useState("");
  const handleMemberPhoneNumber = (value, country) => {
    setMemberNumber(value);
    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setMemberContactNumberCountryCode(dialCode);
      setMemberContactNumber(mobileNumber);
    }
  };


  const memberHandler = (e) => {
    const { name, value } = e.target;
    setMember((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const addressHandler = (e) => {
    const { name, value } = e.target;
    setAddress((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  let count = 0;
  useEffect(() => {

    if (
      window.localStorage.getItem("email") !== null &&
      window.localStorage.getItem("email") !== ""
    ) {
      setMember((prevState) => ({
        ...prevState,
        email: window.localStorage.getItem("email"),
      }));
    }

    if (
      window.localStorage.getItem("name") !== null ||
      window.localStorage.getItem("name") !== ""
    ) {
      setMember((prevState) => ({
        ...prevState,
        firstName: window.localStorage.getItem("name"),
       
      }));
    }

    if (!isNullOrEmpty(window.localStorage.getItem("lastName") )
    ) {
      setMember((prevState) => ({
        ...prevState,
     
        lastName: window.localStorage.getItem("lastName"),
      }));
    }

    if (
      window.localStorage.getItem("phoneNumber") !== null ||
      window.localStorage.getItem("phoneNumber") !== ""
    ) {
      setMember((prevState) => ({
        ...prevState,
        contactNumber: window.localStorage.getItem("phoneNumber"),
      }));
    }
  }, [count]);

  const submitButton = () => {
    if (inputField.name === "") {
      toast.error("Please enter organization name");
      return;
    }
    
    if (inputField.website === "") {
      toast.error("Please enter website ");
      return;
    }
    
    if (contactNumber === "") {
      toast.error("Please enter contact number");
      return;
    }
    
    if (member.firstName === "") {
      toast.error("Please enter member name");
      return;
    }

    if (member.lastName === "") {
      toast.error("Please enter member last name");
      return;
    }

    if (isNullOrEmpty(member.displayName)) {
      toast.error("Please enter display Name");
      return;
    }

    if (member.email === "") {
      toast.error("Please enter member email");
      return;
    }
    if (memberContactNumber === "") {
      toast.error("Please enter member contact number");
      return;
    }
    
    if (accept_terms_and_conditions === false) {
      toast.error("Not accepted terms and conditions");
      return;
    }

    if (accept_privacy_policy === false) {
      toast.error("Not accepted privacy policy");
      return;
    }

    let _mobileNumber = "";
    if (!isNullOrEmpty(contactNumber)) {
      if (!validatePhoneNumber(contactNumber, "+" + contactNumberCountryCode)) {
        toast.error("Please enter valid mobile number");
        return;
      } else {
        _mobileNumber = contactNumberCountryCode + "-" + contactNumber;
      }
    }

    let _memberMobileNumber = "";
    if (!isNullOrEmpty(memberContactNumber)) {
      if (
        !validatePhoneNumber(memberContactNumber, "+" + memberContactNumberCountryCode)
      ) {
        toast.error("Please enter valid office  number");
        return;
      } else {
        _memberMobileNumber = memberContactNumberCountryCode + "-" + memberContactNumber;
      }
    }

    const memberRequest = {
      firstName: member.firstName,
      lastName: member.lastName,
      displayName:member.displayName,
      email: member.email,
      contactNumber: _memberMobileNumber,
    };


       const addressRequest = {
        street: address.street,
        area: address.area,
        city: address.city,
        state: address.state,
        zipcode: address.zipcode,
        country: address.country,
        latitude: address.latitude,
        longitude: address.longitude,
      };
    
    

    const signUpReqest = {
      name: inputField.name,
      website: inputField.website,
      contactNumber: _mobileNumber,
      member: memberRequest,
      address: addressRequest,
      acceptTac: accept_terms_and_conditions,
      acceptPrivacyPol: accept_privacy_policy,
      fcmToken: inputField.fcmToken,
    };

    saveUserDetails(signUpReqest).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var userDetails = response.data;
          toast.success("Your account has been created successfully");
         
          employeeLoginService().then((response) => {
            if (response.data !== undefined && response.data !== "") {
              const loginResposne = response.data;
              window.localStorage.setItem("user", loginResposne.id);

              if (loginResposne.email !== null) {
                window.localStorage.setItem("email", loginResposne.email);
              }

              if (loginResposne.firstName !== null) {
                window.localStorage.setItem("name", loginResposne.firstName);
              }

              if (!isNullOrEmpty(loginResposne.lastName) ) {
                window.localStorage.setItem("lastName", loginResposne.lastName);
              }

              if (loginResposne.contactNumber !== null) {
                window.localStorage.setItem(
                  "phoneNumber",
                  loginResposne.phoneNumber
                );
              }
              window.localStorage.setItem(
                "employerName",
                loginResposne.employerName
              );
              window.location.href = "/";
            }
          });
        }
      } catch (err) {}
    });
  };
  const handleCallback = (googlePlaces) => {
    setAddress((prevState) => ({
      ...prevState,
      street: googlePlaces.street,
      area: googlePlaces.area,
      city: googlePlaces.city,
      state: googlePlaces.state,
      zipcode: googlePlaces.zipcode,
      country: googlePlaces.country,
      latitude: googlePlaces.latitude,
      longitude: googlePlaces.longitude,
    }));
  };

  const showCandidateAddress = (add) =>{
    var arr = [];
    if(!isNullOrEmpty(add)){
      if(!isNullOrEmpty(add.street)){
        arr.push(add.street)
      }
      if(!isNullOrEmpty(add.area)){
        arr.push(add.area)
      }
      if(!isNullOrEmpty(add.city)){
        arr.push(add.city)
      }
      if(!isNullOrEmpty(add.state)){
        arr.push(add.state)
      }
      if(!isNullOrEmpty(add.country)){
        arr.push(add.country)
      }
      if(!isNullOrEmpty(add.zipcode)){
        arr.push(add.zipcode)
      }
      return arr.join(', ')
    }
    return '';
  };
  return (
    <>
      <Colxx xxs="12">
        <div>
          <CardTitle>
            <h1>Tell us about your organization</h1>
          </CardTitle>
          <CardBody>
            <Row>
              <Colxx sm={12}>
                <div class="row form-group">
                  <Label
                    for="emailHorizontal"
                    className="col-sm-2 col-form-label"
                  >
                    Name*
                    {/* <span className="required-star"></span> */}
                  </Label>
                  <div class="col-sm-10">
                    <input
                      id="emailHorizontal"
                      className="form-control t-rounded-lg"
                      type="name"
                      name="name"
                      onChange={inputsHandler}
                      value={inputField.name}
                      placeholder={"Name"}
                    />
                  </div>
                </div>
              </Colxx>
              <Colxx sm={12}>
                <div class="row form-group">
                  <Label
                    for="emailHorizontal"
                    className="col-sm-2 col-form-label"
                  >
                    {" "}
                    WebSite*
                    {/* <span className="required-star"></span> */}
                  </Label>
                  <div class="col-sm-10">
                    <Input
                      id="emailHorizontal"
                      className="form-control t-rounded-lg"
                      type="website"
                      name="website"
                      onChange={inputsHandler}
                      value={inputField.website}
                      placeholder={"Website"}
                    />
                  </div>
                </div>
              </Colxx>

              <Colxx sm={12}>
                <div class="row form-group">
                  <Label
                    for="emailHorizontal"
                    className="col-sm-2 col-form-label"
                  >
                    Contact Number*
                    {/* <span className="required-star"></span> */}
                  </Label>
                  <div class="col-sm-10">
                    <PhoneInput
                    country='us'
                   
                    countryCodeEditable={false}
                      
                      type="text"
                      name="contactNumber"
                      data-testid="account-contactNumber"
                      placeholder={"Contact Number"}
                      onChange={handlePhoneNumber}
                      value={phoneNumber}
                    />
                  </div>
                </div>
              </Colxx>
            </Row>
            <hr></hr>
            <strong>
              <h3>Address</h3>
            </strong>

            <Row>
              <Colxx sm={12}>
                <FormGroup>
                  <GooglePlacesComponent parentCallback={handleCallback} />
                </FormGroup>
              </Colxx>
              <Colxx>
                <FormGroup>
                  <Colxx sm={12}>
                    <FormGroup>
                      <div class=" form-group">
                        <Row>
                          {showCandidateAddress(address)}
                        </Row>
                      </div>
                    </FormGroup>
                  </Colxx>
                </FormGroup>
              </Colxx>

              {/* <Colxx sm={6}>
                    <FormGroup>
                      <Label>
                        Line 1
                       
                      </Label>
                      <Input
                        type="text"
                        name="street"
                       // data-testid="account-street"
                       value={address.street}
                       disabled
                        placeholder={"Line 1"}
                        onChange={addressHandler}
                      
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label>
                        Line 2
                       
                      </Label>
                      <Input
                        type="text"
                        name="area"
                        data-testid="account-area"
                        disabled
                        placeholder={"Line 2"}
                        onChange={addressHandler}
                        value={address.area}
                      />
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={6}>
                    <FormGroup>
                      <Label>
                        City
                      
                      </Label>
                      <Input
                        type="text"
                        name="city"
                        disabled
                        data-testid="account-city"
                        placeholder={"City"}
                        onChange={addressHandler}
                        value={address.city}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label>
                        State
                       
                      </Label>
                      <Input
                        type="text"
                        name="state"
                        disabled
                        data-testid="account-state"
                        placeholder={"State"}
                        onChange={addressHandler}
                        value={address.state}
                      />
                    </FormGroup>
                  </Colxx>
              
               
                  <Colxx sm={6}>
                    <FormGroup>
                      <Label>
                        Zipcode
                      
                      </Label>
                      <Input
                        type="zipcode"
                        name="zipcode"
                        disabled
                        data-testid="account-zipcode"
                        placeholder={"Zipcode"}
                        onChange={addressHandler}
                        value={address.zipcode}
                      />
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={6}>
                    <FormGroup>
                      <Label>
                        Country
                       
                      </Label>
                      <Input
                        type="text"
                        name="country"
                        disabled
                        data-testid="account-country"
                        placeholder={"Country"}
                        onChange={addressHandler}
                        value={address.country}
                      />
                    </FormGroup>
                  </Colxx> */}
            </Row>

            <hr></hr>
            <div class=" form-group">
              <strong>Account Administrator</strong>
            </div>
            <Row>
              <Colxx sm={12}>
                <div class="row form-group">
                  <Label
                    for="emailHorizontal"
                    className="col-sm-2 col-form-label"
                  >
                    First Name*
                    {/* <span className="required-star"></span> */}
                  </Label>
                  <div class="col-sm-10">
                    <Input
                     className="t-rounded-lg"
                      type="name"
                      name="name"
                      onChange={memberHandler}
                      value={member.firstName}
                      placeholder={"First Name"}
                    />
                  </div>
                </div>
              </Colxx>

              <Colxx sm={12}>
                <div class="row form-group">
                  <Label
                    for="emailHorizontal"
                    className="col-sm-2 col-form-label"
                  >
                    Last Name*
                    {/* <span className="required-star"></span> */}
                  </Label>
                  <div class="col-sm-10">
                    <Input
                     className="t-rounded-lg"
                      type="name"
                      name="lastName"
                      onChange={memberHandler}
                      value={member.lastName}
                      placeholder={"Last Name"}
                    />
                  </div>
                </div>
              </Colxx>

              <Colxx sm={12}>
                <div class="row form-group">
                  <Label
                    for="emailHorizontal"
                    className="col-sm-2 col-form-label"
                  >
                    Display Name*
                  </Label>
                  <div class="col-sm-10">
                    <Input
                     className="t-rounded-lg"
                      type="name"
                      name="displayName"
                      onChange={memberHandler}
                      value={member.displayName}
                      placeholder={"Display Name"}
                    />
                  </div>
                </div>
              </Colxx>

              <FormText color="muted"></FormText>

              <Colxx sm={12}>
                <div class="row form-group">
                  <Label
                    for="emailHorizontal"
                    className="col-sm-2 col-form-label"
                  >
                    {" "}
                    Email*
                    {/* <span className="required-star"></span> */}
                  </Label>
                  <div class="col-sm-10">
                    <Input
                     className="t-rounded-lg"
                      type="email"
                      name="email"
                      onChange={memberHandler}
                      value={member.email}
                      placeholder={"email"}
                    />
                  </div>
                </div>
              </Colxx>

              <FormText color="muted"></FormText>
              <Colxx sm={12}>
                <div class="row form-group">
                  <Label
                    for="emailHorizontal"
                    className="col-sm-2 col-form-label"
                  >Contact Number*
                  </Label>
                  <div class="col-sm-10">
                    <PhoneInput
                    country='us'
                    countryCodeEditable={false}
                      type="text"
                      name="memberContactNumber"
                      data-testid="account-contactNumber"
                     
                      onChange={handleMemberPhoneNumber}
                      value={memberNumber}
                    />
                  </div>
                </div>
              </Colxx>

              <FormText color="muted"></FormText>
            </Row>

            <FormGroup> 
               <label>
              <div className="tacbox">
                <input
                  data-testid="account-termsAndConditions"
                  type="checkbox"
                  className="inputterm"
                  checked={accept_terms_and_conditions}
                  onChange={(e) => setAcceptTermsConditions(e.target.checked)}
                />
                <a href="http://teamanics.com.s3-website-us-west-1.amazonaws.com/terms.html" target="_blank" className="emp_icon"> <u>Terms and Conditions*</u></a>
                    {/* <span className="required-star"></span> */}
              </div>
              </label>
            </FormGroup>
            <FormGroup>
            <label>
              <div className="tracbox">
                <input
                  data-testid="account-privacypolicy"
                  type="checkbox"
                  className="inputterm"
                  checked={accept_privacy_policy}
                  onChange={(e) => setAcceptPrivacyPolicy(e.target.checked)}
                />
                   <a href="http://teamanics.com.s3-website-us-west-1.amazonaws.com/privacy.html" target="_blank" className="emp_icon"> <u>Privacy Policy*</u></a> 
                    {/* <span className="required-star"></span> */}
              </div>
              </label>
            </FormGroup>


            <Row>
              <Button
                color="primary"
                size="sm"
                className="mt-4 ml-2"
                outline
                onClick={submitButton}
              >
                Submit
              </Button>

              <Button
                color="primary"
                size="sm"
                className=" mt-4 ml"
                outline
                onClick={firebaseLogout}
              >
                Cancel
              </Button>
            </Row>
          </CardBody>
        </div>
      </Colxx>
    </>
  );
};

export default SignUp;

